import { IconNames } from '../../common/components/Icon/IconNames';

export interface RegistryDataItem {
  iconName: IconNames;
  type: string;
  title: string;
  checkFrequency: string;
  monitoringDetails: string;
  modalDescription: string;
}

interface BuildingInfo {
  unitsCount: number;
  profilesCount: number;
  companiesCount: number;
  address?: string;
}

/**
 * Czech declension helper function
 * @param {number} count - number to decline
 * @param {string} singular - singular form (1)
 * @param {string} plural2to4 - plural form for 2-4 
 * @param {string} plural5plus - plural form for 5+
 * @return {string} correctly declined word
 */
const getCzechDeclension = (count: number, singular: string, plural2to4: string, plural5plus: string): string => {
  if (count === 1) {
    return singular;
  } else if (count >= 2 && count <= 4) {
    return plural2to4;
  } else {
    return plural5plus;
  }
};

export const registryData: RegistryDataItem[] = [
  {
    iconName: "registryCZUK",
    type: "cuzk",
    title: "Katastr nemovitostí",
    checkFrequency: "Kontrolujeme minimálně 1x týdně",
    monitoringDetails: "Načítáme data...",
    modalDescription: "Jakákoliv změna vlastníka jednotky (prodej, dědictví) je naším systémem zaznamenána a o této změně jste informování. V případě zřízení exekučního zástavního práva k jednotce, které je také evidováno v KN, vás o této skutečnosti neprodelene informujeme."
  },
  {
    iconName: "registryInsolvency",
    type: "insolvency-register",
    title: "Insolvenční rejstřík",
    checkFrequency: "Kontrolujeme minimálně 1x týdně",
    monitoringDetails: "Načítáme data...",
    modalDescription: "Pokud by se některý z vlastníků ocitl v insolvenčním návrhu, okamžitě vás o tom budeme informovat. Máte tak dostatek času, aby jste příhlásili pohledávky SVJ do insolvenčního řízení a splnili tak povinnost řádného hospodáře."
  },
  {
    iconName: "registryCompany",
    type: "legal-entity",
    title: "Rejstřík společenství",
    checkFrequency: "Kontrolujeme minimálně 3x týdně",
    monitoringDetails: "Načítáme data...",
    modalDescription: "Kontrolujeme a informujeme o jakékoliv změně statutárních osob ve vašem SVJ v rejstříků společenství."
  },
  {
    iconName: "registryVat",
    type: "vat-register",
    title: "Obchodní věstník a registr plátců DPH",
    checkFrequency: "Kontrolujeme minimálně 1x týdně",
    monitoringDetails: "Načítáme data...",
    modalDescription: "Hlídáme jakékoliv potenciální riziko u společností, které mají na adrese domu sídlo a společnosti, které jsou uvedení jako vlastník, či spoluvlastník jednotky v domě. Informujeme vás v případě vzniku statutu nespolehlivého plátce, či v případě, že je společnost v likvidaci."
  }
];

export const updateRegistryDataWithBuildingInfo = (buildingInfo: BuildingInfo): RegistryDataItem[] => {
  return registryData.map(item => {
    switch (item.type) {
      case "cuzk":
        return {
          ...item,
          monitoringDetails: `Hlídáme u vás ${buildingInfo.unitsCount} ${getCzechDeclension(buildingInfo.unitsCount, 'jednotku', 'jednotky', 'jednotek')} a k nim ${buildingInfo.profilesCount} ${getCzechDeclension(buildingInfo.profilesCount, 'vlastníka', 'vlastníky', 'vlastníků')}`
        };
      case "insolvency-register":
        return {
          ...item,
          monitoringDetails: `Hlídáme u vás ${buildingInfo.profilesCount} ${getCzechDeclension(buildingInfo.profilesCount, 'vlastníka', 'vlastníky', 'vlastníků')}`
        };
      case "legal-entity":
        return {
          ...item,
          monitoringDetails: buildingInfo.address ? `Společenství vlastníků domu ${buildingInfo.address}` : "Načítáme data..."
        };
      case "vat-register":
        return {
          ...item,
          monitoringDetails: `Hlídáme u vás ${buildingInfo.companiesCount} ${getCzechDeclension(buildingInfo.companiesCount, 'společnost', 'společnosti', 'společností')}`
        };
      default:
        return item;
    }
  });
};
